module.exports = __webpack_public_path__ + "static/home-search-form-back-1-d0f787fa7ac9968b4d418d056bc6000e.png";